/* unplugin-vue-components disabled */import script from "./history.vue?vue&type=script&setup=true&lang=ts"
export * from "./history.vue?vue&type=script&setup=true&lang=ts"

import "./history.vue?vue&type=style&index=0&id=fdae2be8&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fdae2be8"]])

export default __exports__